<template lang="html">
  <section>
    <SupplierForm
      v-show="isSupplier"
      :nfe="product_invoice"
    >
      <tpNF :nfe="product_invoice" />
    </SupplierForm>

    <CustomerForm
      v-show="isCustomer"
      :nfe="product_invoice"
      :v="$v"
      :customers="customers"
    >
      <tpNF :nfe="product_invoice" />
    </CustomerForm>

    <refNFe :nfe="product_invoice" />

    <ProductForm :nfe="product_invoice" />
    <TransportForm :nfe="product_invoice" />

    <AdditionalForm
      :nfe="product_invoice"
      :operations="operations"
      :ind-payment-disabled="true"
    />

    <div class="control-button eco-invoice-super-total">
      <button
        type="submit"
        class="button is-primary is-large"
        @click="handleSubmit"
      >
        Emitir
      </button>

      <div class="eco-invoice-total">
        Total Geral: {{ grandTotal | toCurrency }}
      </div>
    </div>
  </section>
</template>

<script>
import { isEmpty } from 'lodash';
import { http } from 'app/v1/src/plugins/http';
import { getData } from 'app/v1/src/utils/get';
import { required } from 'vuelidate/lib/validators';
import { toCurrency } from 'app/v1/src/utils/filters';

import SupplierForm from './Form/Supplier';
import CustomerForm from './Form/Customer';
import ProductForm from './Form/ProductListCart';
import AdditionalForm from './Form/Additional';
import tpNF from './Devolution/tpNF';
import refNFe from './Devolution/refNFe';
import TransportForm from './Form/Transport';

export default {

  components: {
    SupplierForm,
    CustomerForm,
    ProductForm,
    AdditionalForm,
    tpNF,
    refNFe,
    TransportForm,
  },

  filters: {
    toCurrency
  },

  data() {
    return {
      product_invoice: {
        customer_id: '',
        invoiceable_id: '',
        invoiceable_type: 'Customer',
        kind: 'devolution',
        total: 0,
        description: '',
        refNFe: '',
        items_attributes: [],
        natOp: 'Devolução de Mercadoria',
        modFrete: '9',
        indPag: '0',
        tPag: '90',
        tpNF: '1',
        vFrete: 0,
        transporta: {
          xNome: '',
          IE: '',
          xEnder: '',
          xMun: '',
          UF: '',
          cpf_cnpj: ''
        }
      },

      customers: [],

      operations: [
        'Devolução de Mercadoria',
        'Devolução de Mercadoria Recebida para Conserto',
        'Remessa de Mercadorias',
        'Remessa para Conserto'
      ],
    };
  },

  computed: {
    productsTotal: function() {
      return this.product_invoice.items_attributes.reduce((prev, item) => {
        return prev + (parseFloat(item.price) * parseFloat(item.amount));
      }, 0);
    },

    grandTotal: function () {
      return parseFloat(this.productsTotal) + parseFloat(this.product_invoice.vFrete);
    },

    isCustomer: function () {
      return this.product_invoice.invoiceable_type == 'Customer';
    },

    isSupplier: function () {
      return this.product_invoice.invoiceable_type == 'Supplier';
    },
  },

  watch: {
    'product_invoice.tpNF': function(val) {
      if (val == '0') {
        this.product_invoice.invoiceable_id = '';
        this.product_invoice.invoiceable_type = 'Supplier';
      } else {
        this.product_invoice.invoiceable_id = '';
        this.product_invoice.invoiceable_type = 'Customer';
      }
    },
  },

  mounted() {
    this.setCustomers();
  },

  validations: {
    product_invoice: {
      invoiceable_id: { required },
      natOp: { required },
      modFrete: { required },
      refNFe: { required },
      items_attributes: {
        required,
        $each: {
          product_id: { required },
          amount: { required },
          unit: { required },
          cfop: { required },
          price: { required },
        }
      }
    }
  },

  methods: {
    handleSubmit(e) {
      const lastItem = this.product_invoice.items_attributes.slice(-1)[0];

      if(isEmpty(lastItem.selected)) {
        this.product_invoice.items_attributes.pop();
      }

      if (this.$v.product_invoice.$invalid) {
        e.preventDefault();
      } else {
        return this.handleCreateInvoice();
      }
    },

    handleCreateInvoice() {
      const { product_invoice } = this;
      http.post('/api/product_invoices', { product_invoice })
        .then(getData)
        .then(() => Turbolinks.visit('/app/nfes/devolutions'))
        .catch(() => Promise.reject('FAIL_IN_CREATE_INVOICE'));
    },

    setCustomers() {
      http.get('/api/customers')
        .then(getData)
        .then(data => this.customers = data)
        .catch(() => Promise.reject('FAIL_IN_FETCH_CUSTOMERS'));
    },
  }
};
</script>
